export default {
  GET_LIST: '/manage/shoppingCart/orderList',
  GET_REQUEST_LIST: '/manage/orderDocument/findList',
  APPROVE_DOCUMENT: '/manage/orderDocument/approve',
  FIND: '/manage/orderDocument/find/files',
  DONE_OFF: '/manage/orderDocument/doneOff'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/orderList.js